module.exports = "/layout/app/images/bg-veelloman-left.8617a70d.svg";